interface DownloadIACTemplateProps {
  template: string;
  filename: string;
  deploymentType: string;
}

/**
 * Downloads an IAC template file
 * @param props - Object containing template, filename, and deploymentType
 * @param props.template - The template content to download
 * @param props.filename - The base filename (e.g., 'chariot-aws', 'chariot-azure', 'chariot-gcp')
 * @param props.deploymentType - The deployment type (cloudformation, terraform, manual)
 */
export function downloadIACTemplate({
  template,
  filename,
  deploymentType,
}: DownloadIACTemplateProps): void {
  const fileExtension = deploymentType === 'cloudformation' ? 'yml' : 'tf';
  const fileName = `${filename}.${fileExtension}`;

  const blob = new Blob([template], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
